import { cn } from '@plato/ui/util/classes';
import { RadioList, RadioListItem } from '../ui/button-radio-list.tsx';
import type { RadioFilterOption } from './types/filter-types.ts';

type RadioFilterProps = {
    filter: RadioFilterOption;
    onChange: (value: string | null) => void;
    className?: string;
};

export function RadioFilter({ filter, onChange, className }: RadioFilterProps) {
    const handleValueChange = (value: string) => {
        // If the same value is selected, deselect it
        if (value === filter.selectedValue) {
            onChange(null);
        } else {
            onChange(value);
        }
    };

    return (
        <div className={cn('flex flex-col', className)}>
            <RadioList
                value={filter.selectedValue || undefined}
                onValueChange={handleValueChange}
                className="flex flex-col space-y-2"
            >
                {filter.options.map((option) => (
                    <RadioListItem key={option.id} value={option.value} label={option.label} />
                ))}
            </RadioList>
        </div>
    );
}
